import {
    CREATE_PURCHASE_BILL_RETURNS,
    DELETE_PURCHASE_BILL_RETURNS,
    GET_PURCHASE_BILL_RETURNS,
    GET_PURCHASE_BILL_RETURNS_PAGE,
    PURCHASE_BILL_RETURNS_REQUEST,
    PURCHASE_BILL_RETURNS_REQUEST_SUCCESS,
    PURCHASE_BILL_RETURNS_REQUEST_FAILURE,
    UPDATE_PURCHASE_BILL_RETURNS,
    SET_PURCHASE_RETURN_ORDERS
  } from "../types";
  
  const initialState = {
    purchaseBillReturns: [],
    purchaseBillReturnsPage: [],
    returnOrders: [],
    page: 1,
    pageSize: 10,
    search: '',
    where: {},
    total: 0,
    loading: false,
    error: null,
  };
  
  const purchasebillReducer = (state = initialState, action) => {
    switch (action.type) {
      case PURCHASE_BILL_RETURNS_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_PURCHASE_BILL_RETURNS: {
        return {
          ...state,
          purchaseBillReturns: [...action.payload],
          loading: false,
          error: null
        }
      }
      case GET_PURCHASE_BILL_RETURNS_PAGE: {
        const { data, total, page, pageSize, search, where } = action.payload || {};
        return {
          ...state,
          purchaseBillReturnsPage: [...data],
          total,
          page,
          pageSize,
          search: search || '',
          where: where || {},
          loading: false,
          error: null
        }
      }
      case CREATE_PURCHASE_BILL_RETURNS: {
        return {
          ...state,
          purchaseBillReturns: [action.payload, ...state.purchaseBillReturns],
          loading: false,
          error: null
        };
      }
      case UPDATE_PURCHASE_BILL_RETURNS: {
        const purchaseBillReturnsData = state.purchaseBillReturns.slice(0);
        const uIndex = purchaseBillReturnsData.findIndex((data) => data.id === action.payload.id);
        purchaseBillReturnsData.splice(uIndex, 1, { ...action.payload.data });
        return {
          ...state,
          purchaseBillReturns: [ ...purchaseBillReturnsData ],
          loading: false,
          error: null
        };
      }
      case DELETE_PURCHASE_BILL_RETURNS: {
        const purchaseBillReturns = state.purchaseBillReturns?.slice(0);
        const index = purchaseBillReturns.findIndex((data) => data.id === action.id);
        if (index > -1) {
          purchaseBillReturns.splice(index, 1);
        }
        return {
          ...state,
          purchaseBillReturns: [...purchaseBillReturns],
          loading: false,
          error: null
        }
      }
      case SET_PURCHASE_RETURN_ORDERS: {
        return {
          ...state,
          returnOrders: [...action.payload],
          loading: false,
          error: null
        }
      }
      case PURCHASE_BILL_RETURNS_REQUEST_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: null
        }
      }
      case PURCHASE_BILL_RETURNS_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      default:
        return state;
    }
  };
  
  export default purchasebillReducer;
  